import * as React from "react";
import type { SVGProps } from "react";
const SvgMalta = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <defs>
      <style>
        {
          ".Malta_svg__cls-5,.Malta_svg__cls-9{fill:#95867d}.Malta_svg__cls-7{fill:#cfcfcf}.Malta_svg__cls-8{fill:none;stroke:#95867d;stroke-width:.51px}.Malta_svg__cls-9{stroke:#000;stroke-width:.2px}"
        }
      </style>
    </defs>
    <g id="Malta_svg__Malta">
      <path
        id="Malta_svg__rect4"
        d="M640 0h640v720H640z"
        style={{
          fill: "#ce202c",
        }}
      />
      <path
        id="Malta_svg__rect6"
        d="M0 0h640v720H0z"
        style={{
          fill: "#fff",
        }}
      />
      <path
        id="Malta_svg__path2289"
        d="M140.62 129.78c0 1.19-1.34 2.16-3 2.16s-3-1-3-2.16 1.34-2.15 3-2.15 3 .97 3 2.15"
        style={{
          fill: "#f1eded",
        }}
      />
      <path
        id="Malta_svg__path2291"
        d="M46.67 119.39v54.55h54.54c0 9.09 9.09 18.18 18.19 18.18v54.55h54.54v-54.55c9.09 0 18.18-9.09 18.18-18.18h54.55v-54.55h-54.55c0-9.09-9.09-18.18-18.18-18.18V46.67H119.4v54.54c-9.1 0-18.19 9.09-18.19 18.18Z"
        style={{
          fill: "#e31d2f",
        }}
      />
      <path
        id="Malta_svg__path2295"
        d="M50.3 123v47.3h54.55c0 9.09 9.09 18.18 18.18 18.18V243h47.27v-54.52c9.09 0 18.18-9.09 18.18-18.18H243V123h-54.52c0-9.09-9.09-18.18-18.18-18.18V50.3H123v54.55c-9.09 0-18.18 9.09-18.18 18.18Z"
        className="Malta_svg__cls-5"
      />
      <path
        id="Malta_svg__path2297"
        d="M52.12 124.85v43.63h54.55c0 9.09 9.09 18.19 18.18 18.19v54.54h43.63v-54.54c9.1 0 18.19-9.1 18.19-18.19h54.54v-43.63h-54.54c0-9.09-9.09-18.18-18.19-18.18V52.12h-43.63v54.55c-9.09 0-18.18 9.09-18.18 18.18Z"
        style={{
          fill: "#cccbcb",
        }}
      />
      <path
        id="Malta_svg__path2301"
        d="M121.44 106c3.2 3.19 2.33 9.24-1.93 13.5s-10.3 5.12-13.49 1.92-2.34-9.23 1.92-13.49 10.31-5.11 13.5-1.93"
        className="Malta_svg__cls-5"
      />
      <path
        id="Malta_svg__path2303"
        d="m105.37 115.66 1.29-1.29 5.14 2.57-2.57-5.14 1.28-1.29 5.15 10.29z"
        className="Malta_svg__cls-7"
      />
      <path
        id="Malta_svg__rect2305"
        d="M116.68 105.7h1.82v10.91h-1.82z"
        className="Malta_svg__cls-7"
        transform="rotate(-45.01 117.584 111.158)"
      />
      <path
        id="Malta_svg__path2309"
        d="M187.32 121.44c-3.2 3.2-9.24 2.34-13.5-1.92s-5.12-10.31-1.93-13.5 9.24-2.34 13.5 1.92 5.12 10.31 1.93 13.5"
        className="Malta_svg__cls-5"
      />
      <path
        id="Malta_svg__path2311"
        d="m177.68 105.37 1.28 1.29-2.57 5.14 5.14-2.57 1.29 1.29-10.29 5.14 5.15-10.28Z"
        className="Malta_svg__cls-7"
      />
      <path
        id="Malta_svg__rect2313"
        d="M176.72 116.68h10.91v1.82h-10.91z"
        className="Malta_svg__cls-7"
        transform="rotate(-45 182.19 117.595)"
      />
      <path
        id="Malta_svg__path2317"
        d="M171.89 187.32c-3.2-3.19-2.33-9.24 1.93-13.5s10.3-5.12 13.5-1.93 2.33 9.24-1.93 13.5-10.3 5.13-13.5 1.93"
        className="Malta_svg__cls-5"
      />
      <path
        id="Malta_svg__path2319"
        d="m188 177.68-1.32 1.32-5.15-2.57 2.57 5.14-1.28 1.28-5.14-10.28z"
        className="Malta_svg__cls-7"
      />
      <path
        id="Malta_svg__rect2321"
        d="M174.84 176.72h1.82v10.91h-1.82z"
        className="Malta_svg__cls-7"
        transform="rotate(-45 175.736 182.168)"
      />
      <path
        id="Malta_svg__path2325"
        d="M106 171.89c3.19-3.19 9.23-2.33 13.49 1.93s5.13 10.31 1.93 13.5-9.24 2.33-13.5-1.93-5.12-10.3-1.92-13.5"
        className="Malta_svg__cls-5"
      />
      <path
        id="Malta_svg__path2327"
        d="m115.66 188-1.29-1.28 2.57-5.15-5.14 2.58-1.29-1.29 10.29-5.14z"
        className="Malta_svg__cls-7"
      />
      <path
        id="Malta_svg__rect2329"
        d="M105.7 174.84h10.91v1.82H105.7z"
        className="Malta_svg__cls-7"
        transform="rotate(-45 111.16 175.756)"
      />
      <path
        id="Malta_svg__path2331"
        d="M184.85 146.67a38.18 38.18 0 1 1-38.18-38.19 38.18 38.18 0 0 1 38.18 38.19Z"
        className="Malta_svg__cls-8"
      />
      <path
        id="Malta_svg__path2333"
        d="M175.76 146.67a29.09 29.09 0 1 1-29.09-29.1 29.1 29.1 0 0 1 29.09 29.1Z"
        className="Malta_svg__cls-8"
      />
      <path
        id="Malta_svg__path2335"
        d="M133.94 177.58a1.82 1.82 0 1 1-2.73-1.58 1.8 1.8 0 0 1 1.82 0 1.84 1.84 0 0 1 .91 1.58"
      />
      <path
        id="Malta_svg__path2337"
        d="M163 177.58a1.82 1.82 0 1 1-2.7-1.58 1.8 1.8 0 0 1 1.82 0 1.84 1.84 0 0 1 .91 1.58Z"
      />
      <path
        id="Malta_svg__path2339"
        d="M145.45 177.58v1.89H143c-2.42 0-2.42 1.9 0 1.9h2.42v1.9c0 2 2.12 2.2 2.27.16l.16-2.05h2.42c2.43 0 2.43-1.9 0-1.9h-2.42v-1.89a1.23 1.23 0 1 0-2.43 0Z"
      />
      <path
        id="Malta_svg__path4942"
        d="M167.42 152.22a6 6 0 0 1 1.69 0s.09.44-.18.59a4.5 4.5 0 0 0 1.41.12s-.43.33-.64.46a2 2 0 0 1 .89.56 2.8 2.8 0 0 1-1.32-.07 2 2 0 0 1 .21.93 3.57 3.57 0 0 1-2-1.36"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4944"
        d="M164.93 151.39c-.36.9-3-.77-3-.77a4.74 4.74 0 0 0 2.92 2.07"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4946"
        d="M131.82 168.4h31.05l2.4-1.91-4-2.15-6.15-2.09-2.46-1.36-4.55.25-3.81 2-5.23.61-1.23 1.42-3.87.31-6.09-.13L138 167l-8.37-.43Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4948"
        d="M148.54 159.48c-3.89-2.09-5 3.06-6.7 4.3 2.26.39 4-1.73 5.9-2.76 1.47 4 3.79 1.35 3.79 1.35s2.41 3.83 5.62 2.09a1.72 1.72 0 0 0 1.85.06s1.16.22 1.41-.31c.62.22 1.29-.55 1.29-.55s1.34 0 1.6-.68c2 .36 4.61-4 4.61-4l.8-1.54 1.17-.25s.08-.77-.55-.73c0-.47-.42-.71-1-.62.11-.28-.3-.49-.3-.49-1.11.27-1.17 3.07-1.17 3.07s-1.94 1.48-2.65 1.85c0-1.6-2.7-3.77-2.15-4.8s2.29 1.58 3.81 1.11 2.27-2.46 2.34-4a28 28 0 0 0-1.48-2.77l-1-.06-.86-2.09s-1.81 1.19-1.78 2.22 1.9 1.9 1.9 1.9a2.9 2.9 0 0 1-2.09.37c-.09 1.05 1.23.85 1.72.86a2.4 2.4 0 0 0 1 1.17s.46 1.15-.74 1.05-2.61-2.88-4.3-1.6.79 3.81.79 3.81a6.36 6.36 0 0 0-2.52 3c-3.8-3.33-6.05-1.82-10.31-.96Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4950"
        d="M143 154c1.6 1.5.48 4 1.1 4.49s1.6-.25 1.6-.25c1.68.45 4.68-.49 4.68-.49 1.32.74.79-.35 1.59-.31.71 1.81 3.08 1.48 3.08 1.48a17.5 17.5 0 0 0-3.51-2.83c-1 .61-4 .7-4.55.61s-.21-.81-.49-1.23c1.1-1.07.23-3.73-.37-4.73-2.44-1.63-5.36 1.16-3.13 3.26Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4952"
        d="M132.32 149.5c-2 .54-5.5-2.6-7.13-1.39s-.87 4.17.21 5.65-1.55 2-2.26 2.83.22 1.74.22 1.74l.74.47-.13 1.09.39 1.31s.36.31.48-.09c.34.34 0 1.31.87 1.43-.3-.62.22-2.35.22-2.35s1.45.11 1.82-.52-.35-2-.35-2h.44c-.49-.33-.65-1.34-.65-1.34s2-.65 2-2.18-3.29-3.16-2.09-4 3.63 2.29 5.61.83.7 0 .7 0 .89-1.98-1.09-1.48Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4954"
        d="M142.7 128c-2.69-1.13-8.18-1.2-11.25-2.71a2.12 2.12 0 0 0-2 1.57c-1.41-.07-2.36 2.14-2.15 2.58-2.56-1-3.75 3-2.92 3.84-2.19.1-1.92 2.89-2.12 3.66-.7 1.7.15 2.27 1.53 1.66.21.74-.08 1.15-.7 1.29 3.79 4.34 5.93-2.66 9.25-2.64 4.15-1.22 5.78-3.26 5.78-3.26l1.63.22Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4956"
        d="M150.14 124.86a4 4 0 1 1-4-4 4 4 0 0 1 4 4Z"
        style={{
          fill: "#95867d",
          stroke: "#000",
          strokeWidth: ".2px",
          strokeLinecap: "round",
        }}
      />
      <path
        id="Malta_svg__path4958"
        d="M139.2 156.1c-2.46-.45-6.54-3-6.95-6.34 2.29-9 14.1-4.29 15.12-11.06a20.3 20.3 0 0 1 3-12.61 5.43 5.43 0 0 1 2.64-1.84 2.32 2.32 0 0 1-.12 1.59c2-.21 4.63.88 6.46 1a2.76 2.76 0 0 1 .36 2.15c-.12.66-.86.49-.86.49a2.31 2.31 0 0 1-2.33.68 7.3 7.3 0 0 1-3 .92s4.28 4.51 3.57 5.9a9.2 9.2 0 0 1 2.21 2.4s2.92-1.54 3.88-3c1.69 0 4.46 1.77 5.84 2 1.69 1.37 3.38 2.77 3.38 2.77s-2 1.32-2.89-.44c-1.06.1-3.35-2.44-6.52-1.66-.09 2.82-3.19 4.8-3.19 4.8s2.89-.4 4.48.55c1.65 1.39 4.06 3.26 4.06 3.26l2.15 3.69s-2 .34-2.7-2.21c-.74 2.06-.77-1.28-3.69-2.83a2.23 2.23 0 0 1-2.09-.43c-2.11.57-4.6 1.8-7.56 1.48-2.11.66-3.65 2.41-5.78 3.38s-2.77.49-2.77.49l-1.72.06c-.25 1-.11 2.62-1.05 2.89.6.65-.43 3.4-1.47 3.87.49 1.77 1.93 2.31 3.44 3.2a2.21 2.21 0 0 1 2.21.19 11.2 11.2 0 0 1 1.79 3.07 8.9 8.9 0 0 1-2.4-.12c-.58-.25-.63-.85-1.29-.68-4.17-3.7-6.37-2.23-6.77-3.07s1-3.12.56-4.55Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4960"
        d="M129.19 139.58c.22-.27 1.74.31 1.74.31l2.78 1.74 5.65 3.65 2 2.91-3.61-1.19-5-4.3-2.69-1.7s-1.06-1.14-.87-1.42Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4962"
        d="M162.62 148.84c-2-.49-6.76 5.35-6.76 5.35l3.63 3.94s.11-6.71 3.13-9.29Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4964"
        d="M138.83 132.55c-1.07 1.36-1.16 4.11.22 5.22.13 1.67 1.55 5 2.67 5.35s6.08 1.48 8 1.17c-.36 3.09 2.06 5.57 4.31 7.2a1.33 1.33 0 0 0 .23.95c.26.34 1.44.4 1.49.21.52.74 3 1.06 3.24.73s-3.73-3-4.6-3.86a24 24 0 0 1-2.46-6.89 7.28 7.28 0 0 0-5.2-2.23l.1-4.47.19-5-1.79-.93a2.1 2.1 0 0 0 .56-.37c.43.19 1.24-.68 1.35-.92.41.14.78.14.85-.08s.14-1.06.29-1.5c1.34-1.19-.2-3.7-2.26-3.74s-2.49 2.43-2.45 2.62c.19.77.15 1.16 0 1.35a5.5 5.5 0 0 1-.86.62 3.4 3.4 0 0 0-2.52 0c-1.38.53-2.94 1.26-3 2.15a2.8 2.8 0 0 0-1.85 1.6c-.55-.11-1.27.35-2.46 2.27-2.12.94-2.24 5.47-2.24 5.47a4 4 0 0 0-.6 1.28c0 .44.2.85.48.77 0 .29.41.55.58.46.06.29.48.45.74.41 0 .2.84.15.9 0s-.08-1.19 0-1.27.77.44.95.31 0-.59-.14-.76-.67-.32-.81-1a3.36 3.36 0 0 1 .37-1.73s2.3-1.81 2.57-3.36c1.73.17 2.65-1.35 3.15-1.92Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4966"
        d="M134.81 126c.53-1.28 2.43-1.16 2.43-1.16s.68-1.8 3.25-.73c1-.74 3.5.33 3.5.33a2.79 2.79 0 0 1 2.2-1.13 2.68 2.68 0 0 1 2.55 2.76c-1.26.31-3.45-1-5.12-.65-1 .55-2.54 1.13-3.13 1.92-1.49.2-3.19-1.34-5.68-1.34Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4968"
        d="M139.63 128.18c.57-.35 2-1 3-.21a16.6 16.6 0 0 0 2.55 2.09l1.75.73.8.5-.52 8c-1.62-1.66-3.14-1.95-4.31-3.9-.62-.84-.14-2.86-1.22-4.18s-2.29-2.21-2.05-3.03Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4970"
        d="M143.84 130.5s.92-.18 1.17 0 .63.2.72.48c.35.1.59.28.59.54.32.09.46.68.46.68l-.31.45a1.3 1.3 0 0 1-.39-.67c-.22-.11-.71-.22-.83-.54a.71.71 0 0 1-.69-.57c-.36.13-.72-.37-.72-.37Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4972"
        d="M151.62 125.26c-.53-.58-1.45-.15-1.45-.15l-2.46 4.24-1.07.89-.1 3.32.9 3.11-.31 2.39a5.9 5.9 0 0 0 1.38-1.81 9.6 9.6 0 0 0-.46-2.64s-.74-1.26.15-3.6 2.92-4.27 3.42-5.75Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4974"
        d="M157.69 129a21.63 21.63 0 0 1-10.13 7.44c-1.74.42-1.11-4.06-1.11-4.06l-.43.13s-1 4.38 1.35 4.42c6.32-1.24 11.06-7.89 11.06-7.89Z"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4976"
        d="M160.29 160.59a1.29 1.29 0 0 1-1.36 0 1.78 1.78 0 0 0-1.47-1s-.69-2-1.78-1.41c-.17-1-1.36-.49-1.36-.49s0-1.49-1.41-1.29c.46-1.71-1.91-1.6-1.91-1.6s-.07-1.93-3.56-1.54c7.51-3.37 13.46 5.29 13.46 5.29"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4978"
        d="M163.85 161.32s1.74 2 2.65 2 1-1.9 1-1.9.29.83.74.61a.73.73 0 0 0 .55.74s-1.56 3.64-6 .18"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__path4980"
        d="m150.26 162.06-.61 2.52s-.78.71-.55.86 1.47-.24 1.47-.24a6.1 6.1 0 0 0 2.52-.8 1.64 1.64 0 0 0 1.29 1 1.1 1.1 0 0 0-.06-.61 1.8 1.8 0 0 0 .8-.06s.25-.71-.31-1c.07-.52.33-1-.61-.92-.69.74-2.4 1.58-2.83 1.29s1.69-1.23 1.11-2.46"
        className="Malta_svg__cls-9"
      />
      <path
        id="Malta_svg__text1930"
        d="m111.14 156.08 2.5-.59-.27-1.16a.85.85 0 0 0-.32-.55 1.23 1.23 0 0 0-.75-.08v-.17l2.15-.51v.17a1.3 1.3 0 0 0-.52.23.6.6 0 0 0-.2.31 1.1 1.1 0 0 0 0 .5l.27 1.16 2-.47a2.2 2.2 0 0 0 .63-.22.42.42 0 0 0 .15-.24.9.9 0 0 0 0-.46v-.23h.17l.65 2.73h-.17l-.06-.23a.68.68 0 0 0-.36-.51 1.5 1.5 0 0 0-.75.06l-4.11 1a2 2 0 0 0-.63.21.42.42 0 0 0-.15.24.9.9 0 0 0 0 .46l.05.22h-.17l-1.13-4.74 1.38-.39v.16a2 2 0 0 0-.58.44.87.87 0 0 0-.21.47 2 2 0 0 0 .08.76l.33 1.4Zm-1.61-11.28a3 3 0 0 1 1.09-2.15 3.4 3.4 0 0 1 2.47-.8 3.46 3.46 0 0 1 2.41 1.08 3 3 0 0 1 .86 2.33 3 3 0 0 1-1.09 2.21 3.4 3.4 0 0 1-2.53.78 3.33 3.33 0 0 1-2.48-1.2 3.2 3.2 0 0 1-.73-2.25m.35.11a1.72 1.72 0 0 0 .57 1.44 3.7 3.7 0 0 0 2.33.8 3.9 3.9 0 0 0 2.5-.55 1.66 1.66 0 0 0 .73-1.35 1.88 1.88 0 0 0-.63-1.56 3.54 3.54 0 0 0-2.23-.73 4 4 0 0 0-2.53.52 1.8 1.8 0 0 0-.74 1.43m9.47-11.91-.62 1.63-3.64 1-.09.37a.6.6 0 0 1 0 .12l-.06.14 1.78.68a1.34 1.34 0 0 0 .76.14.69.69 0 0 0 .4-.43l.09-.24.17.06-1 2.62-.17-.06.09-.23a.67.67 0 0 0 0-.65 1.5 1.5 0 0 0-.63-.35l-4-1.5a1.3 1.3 0 0 0-.76-.15.73.73 0 0 0-.4.45l-.09.23-.16-.07.84-2.22a6 6 0 0 1 .69-1.39 1.8 1.8 0 0 1 .82-.58 1.5 1.5 0 0 1 1 0 1.55 1.55 0 0 1 .83.74 2.18 2.18 0 0 1 .16 1.36l2.23-.59a3.4 3.4 0 0 0 1.08-.44 2 2 0 0 0 .57-.71Zm-4.79 3.14.06-.14v-.11a2.12 2.12 0 0 0 .12-1.46 1.3 1.3 0 0 0-.79-.81 1.31 1.31 0 0 0-1.79.82 3.5 3.5 0 0 0-.18.74Zm13.91-21.66 1.27 1.64-.14.09a2.8 2.8 0 0 0-1.19-.61 2 2 0 0 0-1.56.34 2.11 2.11 0 0 0-1.06 1.86 3.5 3.5 0 0 0 .62 2 3.94 3.94 0 0 0 1.23 1.24 2.55 2.55 0 0 0 1.41.44 2.33 2.33 0 0 0 1.21-.36 2.6 2.6 0 0 0 .53-.45 2.7 2.7 0 0 0 .4-.59l-1-1.58a1.7 1.7 0 0 0-.42-.5.5.5 0 0 0-.32-.07 1.35 1.35 0 0 0-.5.23l-.1-.15 2.12-1.38.1.16-.1.06a.55.55 0 0 0-.3.49 1.8 1.8 0 0 0 .31.65l1.02 1.61a5 5 0 0 1-.68 1 5 5 0 0 1-.93.77 3.49 3.49 0 0 1-3.08.55 3.28 3.28 0 0 1-1.76-1.37 3.6 3.6 0 0 1-.55-1.61 3.55 3.55 0 0 1 .35-2 3.36 3.36 0 0 1 1.19-1.28 4 4 0 0 1 .58-.3 6 6 0 0 1 .83-.23 1.3 1.3 0 0 0 .36-.12.2.2 0 0 0 .09-.15.7.7 0 0 0-.11-.32l.14-.1Zm10.65.74-2.44.65-.17 1.11a1.7 1.7 0 0 0 0 .59.33.33 0 0 0 .21.22 1.23 1.23 0 0 0 .63 0v.18l-2 .53v-.18a1 1 0 0 0 .46-.32 2.9 2.9 0 0 0 .29-1l.84-5.8h.16l3.6 4.67a2.5 2.5 0 0 0 .7.7 1.1 1.1 0 0 0 .66 0v.17l-2.49.66v-.17a1 1 0 0 0 .47-.26.37.37 0 0 0 .07-.3 2.4 2.4 0 0 0-.36-.6l-.63-.8Zm-.22-.31-1.75-2.27-.42 2.85zm11.55 0h.15l-.62 1.76-5.06-.2v-.18h.25a.64.64 0 0 0 .6-.25 1.5 1.5 0 0 0 .13-.71l.16-4.21a1.27 1.27 0 0 0-.1-.77.7.7 0 0 0-.55-.24h-.25v-.18l3 .12v.18a1.6 1.6 0 0 0-.73.07.62.62 0 0 0-.3.24 2.1 2.1 0 0 0-.1.73l-.16 4.11a1.15 1.15 0 0 0 0 .55.44.44 0 0 0 .17.16 3.7 3.7 0 0 0 .75.08h.48a3.3 3.3 0 0 0 1.06-.07 1.3 1.3 0 0 0 .57-.37 3.5 3.5 0 0 0 .54-.87Zm8.7 2.33.14.09-1.08 1.51-4.81-1.59.06-.17.23.07a.64.64 0 0 0 .65-.07 1.6 1.6 0 0 0 .32-.64l1.32-4a1.27 1.27 0 0 0 .11-.77.72.72 0 0 0-.46-.38l-.23-.07v-.17l2.81.93v.17a1.7 1.7 0 0 0-.73-.14.6.6 0 0 0-.35.15 2.1 2.1 0 0 0-.3.68l-1.29 3.9a1.2 1.2 0 0 0-.1.54.28.28 0 0 0 .12.2 2.8 2.8 0 0 0 .7.28l.45.15a3.3 3.3 0 0 0 1 .23 1.4 1.4 0 0 0 .65-.2 2.8 2.8 0 0 0 .75-.69Zm7 3.72-2.06-1.46-1 .58a1.7 1.7 0 0 0-.46.37.34.34 0 0 0 0 .3 1.16 1.16 0 0 0 .42.48l-.11.14-1.68-1.19.11-.14a1.15 1.15 0 0 0 .54.15 3 3 0 0 0 1-.45l5-3.07.14.1-1.28 5.76a2.3 2.3 0 0 0-.09 1 1.1 1.1 0 0 0 .38.54l-.1.14-2.11-1.49.11-.14a1.05 1.05 0 0 0 .5.2.36.36 0 0 0 .27-.14 2.1 2.1 0 0 0 .23-.66l.22-1Zm.1-.37.62-2.8-2.46 1.5ZM174 122l1.06 1.43-1.56 6.13 3-2.25c.32-.24.5-.42.53-.55a.74.74 0 0 0-.18-.58l-.13-.18.14-.11 1.36 1.83-.15.11-.14-.19a.64.64 0 0 0-.55-.32 1.55 1.55 0 0 0-.63.33l-4.42 3.29-.11-.14 1.67-6.6-3.24 2.39c-.32.24-.5.43-.53.56a.74.74 0 0 0 .18.57l.14.19-.15.1-1.29-1.87.14-.11.13.18a.69.69 0 0 0 .56.33 1.6 1.6 0 0 0 .63-.34l3.65-2.7a3 3 0 0 0 .1-.61 1.7 1.7 0 0 0-.1-.47 1.6 1.6 0 0 0-.22-.36zm8.25 15.2-1.42.58-.06-.18a1.6 1.6 0 0 0 .49-.33.9.9 0 0 0 .26-.51 1.35 1.35 0 0 0-.09-.66l-.31-.87-4.71 1.67a1.4 1.4 0 0 0-.67.37.77.77 0 0 0 0 .6l.08.22-.17.05-.93-2.61.17-.06.08.22a.66.66 0 0 0 .43.47 1.5 1.5 0 0 0 .7-.13l4.71-1.67-.26-.74a2.2 2.2 0 0 0-.28-.59.84.84 0 0 0-.48-.29 1.54 1.54 0 0 0-.73 0l-.06-.17 1.47-.44 1.78 5Zm-5.18 11.59L177 147l2.94-2.37v-.53a.4.4 0 0 1 0-.15l-1.9.1a1.37 1.37 0 0 0-.76.17.65.65 0 0 0-.18.56v.22h-.18l-.14-2.8h.17v.24a.64.64 0 0 0 .3.58 1.5 1.5 0 0 0 .71.07l4.22-.22a1.3 1.3 0 0 0 .76-.18.73.73 0 0 0 .18-.57v-.24h.18l.12 2.38a5.7 5.7 0 0 1-.07 1.54 1.87 1.87 0 0 1-.52.87 1.46 1.46 0 0 1-.95.39 1.53 1.53 0 0 1-1.07-.34 2.24 2.24 0 0 1-.68-1.18l-1.82 1.46a3.7 3.7 0 0 0-.81.84 2 2 0 0 0-.23.89Zm3.12-4.81v.16a.5.5 0 0 1 0 .11 2.08 2.08 0 0 0 .48 1.39 1.29 1.29 0 0 0 1.05.42 1.31 1.31 0 0 0 1.31-1.47 5.4 5.4 0 0 0-.13-.75l-2.72.14Zm1.81 13.4-.58 2.21h-.17v-.13a1 1 0 0 0 0-.38 1.4 1.4 0 0 0-.2-.5 4.3 4.3 0 0 0-.53-.65l-2-2.15-1.59-.42a1.3 1.3 0 0 0-.76-.06.8.8 0 0 0-.34.51v.21h-.18l.71-2.69h.17l-.06.22a.69.69 0 0 0 .09.64 1.7 1.7 0 0 0 .66.28l1.5.39 3.1-1a3.7 3.7 0 0 0 .69-.27 1.6 1.6 0 0 0 .4-.38.6.6 0 0 0 .12-.25h.17l-.71 2.71h-.17v-.14a.8.8 0 0 0 0-.43.33.33 0 0 0-.26-.26 1.5 1.5 0 0 0-.68.12l-2.38.79 1.62 1.75a1.54 1.54 0 0 0 .58.45.42.42 0 0 0 .25 0 .38.38 0 0 0 .21-.15.9.9 0 0 0 .16-.36h.17Z"
      />
    </g>
  </svg>
);
export default SvgMalta;
